import { useState, useEffect, useRef } from 'react';
import { motion, useInView, useScroll, useTransform } from 'framer-motion';
import Header from '@/components/Header';
import HeroSection from '@/components/HeroSection';
import BetterRoofSection from '@/components/BetterRoofSection';
import ServicesSection from '@/components/ServicesSection';
import ReviewsSection from '@/components/ReviewsSection';
import CTABanner from '@/components/CTABanner';
import SuburbsSection from '@/components/SuburbsSection';
import Footer from '@/components/Footer';
import FloatingBadge from '@/components/FloatingBadge';
import Marquee from '@/components/Marquee';

export default function HomePage() {
  const [isLoaded, setIsLoaded] = useState(false);
  const heroRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: heroRef,
    offset: ["start start", "end start"]
  });
  
  const heroOpacity = useTransform(scrollYProgress, [0, 0.5], [1, 0]);
  const heroScale = useTransform(scrollYProgress, [0, 0.5], [1, 0.95]);

  useEffect(() => {
    const timer = setTimeout(() => setIsLoaded(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen bg-[#0B111E]" data-testid="main-page">
      <Header />
      
      <motion.div 
        ref={heroRef}
        style={{ opacity: heroOpacity, scale: heroScale }}
      >
        <HeroSection isLoaded={isLoaded} />
      </motion.div>

      <Marquee />
      
      <BetterRoofSection />
      
      <ServicesSection />
      
      <CTABanner />
      
      <ReviewsSection />
      
      <SuburbsSection />
      
      <Footer />
      
      <FloatingBadge />
    </div>
  );
}
